import { useEffect } from 'react';
import { connect } from 'react-redux';

import useMeasure from 'src/hooks/useMeasure';
import commonActions from 'src/redux/commonRedux/actions';
import { IRootState } from 'src/redux/rootReducer';
import './styles.scss';

const ResponsiveContainer: React.FC<Props> = ({ isShow, onToggleSidebar, onSetCollapseSidebar }) => {
  const {
    bind,
    bounds: { width },
  } = useMeasure();

  useEffect(() => {
    if (width >= 768) {
      onToggleSidebar(true);
      onSetCollapseSidebar(false);
    } else {
      onSetCollapseSidebar(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [width]);

  return <div className="ctn-responsive" {...bind} />;
};

type Props = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps & {
    isLoading?: boolean;
  };

const mapStateToProps = (state: IRootState) => ({
  isShow: state.common.showSidebar,
});

const mapDispatchToProps = {
  onToggleSidebar: commonActions.setSidebar,
  onSetCollapseSidebar: commonActions.setCollapseSidebar,
};

export default connect(mapStateToProps, mapDispatchToProps)(ResponsiveContainer);
